import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class MovieApiService {
  constructor(private http: HttpClient) {}

  // Movies

  getMovie = (id: string) => this.http.get(`/api/v1.0/movies/${id}`);

  getAvailableMovies = (params: Record<string, string>) => this.http.get('/api/v1.0/movies?movie_statuses=2', { params });

  getShopUnassignedMovies = (params: Record<string, string>) => this.http.get(`/api/v1.0/movies/unassigned?movie_statuses=2`, { params });

  movieBulkAction = (body: Record<string, unknown>) => this.http.post('/api/v1.0/movies/bulk', body);

  getPeople = (params: Record<string, string>) => this.http.get('/api/v1.0/movies/people/autocomplete', { params });

  // Shop

  getShopMovie = (id: string) => this.http.get(`/api/v1.0/shop-movies/${id}`);

  getShopMovies = (params: Record<string, string>) => this.http.get('/api/v1.0/shop-movies', { params });

  // Shows

  importShows = () => this.http.post('/api/v1.0/shows/import', {});

  getShows = (params: Record<string, string>) => this.http.get('/api/v1.0/shows', { params });

  removeShows = (showIds: string[], shopId: string) =>
    this.http.post('/api/v1.0/shows/bulk', { ids: showIds, action: 'delete', filter: { shop: shopId } });

  setShowsStatusToImported = (showIds: string[], shopId: string) =>
    this.http.post('/api/v1.0/shows/bulk', { ids: showIds, action: 'status-Imported', filter: { shop: shopId } });

  setShowsStatusToPublished = (showIds: string[], shopId: string) =>
    this.http.post('/api/v1.0/shows/bulk', { ids: showIds, action: 'status-Published', filter: { shop: shopId } });

  addShopMovie = (movie: Record<string, unknown>) => this.http.post('/api/v1.0/shop-movies', movie);

  editShopMovie = (movie: Record<string, unknown>) => this.http.put('/api/v1.0/shop-movies', movie);

  updateShopMovieStatus = (body: Record<string, unknown>) => this.http.post('/api/v1.0/shop-movies/bulk', body);

  removeShopMovie = (shopMovieId: string) => this.http.delete(`/api/v1.0/shop-movies/${shopMovieId}`);

  // Events

  getEvent = (id: string) => this.http.get(`/api/v1.0/events/${id}`);

  getEvents = (params: Record<string, string>) => this.http.get('/api/v1.0/events', { params });

  addEvent = (body: Record<string, unknown>) => this.http.post('/api/v1.0/events', body);

  editEvent = (body: Record<string, unknown>) => this.http.put('/api/v1.0/events', body);

  removeEvent = (id: string) => this.http.delete(`/api/v1.0/events/${id}`);

  inviteUserToAnEvent = (eventId: string, body: Record<string, unknown>) => this.http.post(`/api/v1.0/events/${eventId}/users`, body);

  resendInvite = (inviteId: string) => this.http.post(`/api/v1.0/events/invite/${inviteId}/resend`, {});

  getEventUsers = (eventId: string, params: Record<string, string>) => this.http.get(`/api/v1.0/events/${eventId}/users`, { params });

  removeEventUser = (eventId: string, userId: string) => this.http.delete(`/api/v1.0/events/${eventId}/users/${userId}`);

  removeInvitation = (eventId: string, userEmail: string) =>
    this.http.delete(`/api/v1.0/events/${eventId}/invite`, { params: { email: userEmail } });

  getInvitationPreview = (eventId: string, body: Record<string, unknown>) =>
    this.http.post(`/api/v1.0/events/${eventId}/invite/preview`, body, { responseType: 'text' });

  bulkEventInviteAction = (body: Record<string, unknown>) => this.http.post(`/api/v1.0/events/invite/bulk`, body);

  exportInvites = (body: Record<string, unknown>) => this.http.post(`/api/v1.0/events/invite/export`, body, { responseType: 'text' });

  // Quizzes

  getUnassignedQuizzes = (params: Record<string, string>) => this.http.get('/api/v1.0/quizzes/unassigned', { params });

  getQuiz = (quizId: string) => this.http.get(`/api/v1.0/quizzes/${quizId}`);

  getShopQuizzes = (params: Record<string, string>) => this.http.get('/api/v1.0/shop-quizzes', { params });

  getShopQuiz = (quizId: string) => this.http.get(`/api/v1.0/shop-quizzes/${quizId}`);

  assignQuiz = (quiz: Record<string, unknown>) => this.http.post(`/api/v1.0/shop-quizzes`, quiz);

  editShopQuiz = (quiz: Record<string, unknown>) => this.http.put(`/api/v1.0/shop-quizzes`, quiz);

  removeShopQuiz = (quizId: string) => this.http.delete(`/api/v1.0/shop-quizzes/${quizId}`);

  updateShopQuizStatus = (body: Record<string, unknown>) => this.http.put('/api/v1.0/shop-quizzes/status', body);
}
